"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloodRisk$ = exports.FloodRisk$outboundSchema = exports.FloodRisk$inboundSchema = void 0;
exports.floodRiskToJSON = floodRiskToJSON;
exports.floodRiskFromJSON = floodRiskFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const riversandseas_js_1 = require("./riversandseas.js");
const surfacewater_js_1 = require("./surfacewater.js");
/** @internal */
exports.FloodRisk$inboundSchema = z.object({
    rivers_and_seas: z.nullable(riversandseas_js_1.RiversAndSeas$inboundSchema),
    surface_water: z.nullable(surfacewater_js_1.SurfaceWater$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "rivers_and_seas": "riversAndSeas",
        "surface_water": "surfaceWater",
    });
});
/** @internal */
exports.FloodRisk$outboundSchema = z.object({
    riversAndSeas: z.nullable(riversandseas_js_1.RiversAndSeas$outboundSchema),
    surfaceWater: z.nullable(surfacewater_js_1.SurfaceWater$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        riversAndSeas: "rivers_and_seas",
        surfaceWater: "surface_water",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FloodRisk$;
(function (FloodRisk$) {
    /** @deprecated use `FloodRisk$inboundSchema` instead. */
    FloodRisk$.inboundSchema = exports.FloodRisk$inboundSchema;
    /** @deprecated use `FloodRisk$outboundSchema` instead. */
    FloodRisk$.outboundSchema = exports.FloodRisk$outboundSchema;
})(FloodRisk$ || (exports.FloodRisk$ = FloodRisk$ = {}));
function floodRiskToJSON(floodRisk) {
    return JSON.stringify(exports.FloodRisk$outboundSchema.parse(floodRisk));
}
function floodRiskFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FloodRisk$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'FloodRisk' from JSON`);
}
//# sourceMappingURL=floodrisk.js.map